<template>
  <div>
    <v-app-bar
      app
      dense
      color="white"
      style="border: 1px solid rgba(0, 0, 0, 0.05);border-radius: 0px 0px 1rem 1rem ;"
      elevation="0"
      flat
    >
      <v-toolbar-title>
        <v-app-bar-nav-icon @click.stop="changeMini"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="actionItem('')">
        <v-icon>mdi-export</v-icon>
      </v-btn>
      <!-- <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="px-0" v-on="on" icon color="#008ef8">
            <v-avatar size="36">
              <img :src="resultKaryawan.profile_picture" alt="Naruto" />
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              @click="actionItem(item.to)"
            >
              <v-list-item-icon class="pr-0 mr-3">
                <v-icon class="text-12" :color="item.color">{{
                  item.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-12">{{
                item.title
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu> -->
    </v-app-bar>
  </div>
</template>

<script>
import Cookies from "js-cookie";
// import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const system = createNamespacedHelpers("system");
// const user = createNamespacedHelpers("karyawan");

export default {
  name: "AppHeader",
  data() {
    return {
      tempLogin: JSON.parse(Cookies.get("userdata_login")),
      account: null,
      outletList: [
        {
          outlet_name: "GBB"
        },
        {
          outlet_name: "KPT"
        }
      ],
      items: [
        {
          title: "Setting Profile",
          to: "/setting/profile/",
          color: "#00000",
          icon: "mdi-account"
        },
        {
          title: "Change Password",
          to: "/setting/password/",
          color: "#219bf7",
          icon: "mdi-key"
        },
        {
          title: "Logout",
          to: "",
          color: "red",
          icon: "mdi-logout"
        }
      ]
    };
  },
  mounted() {
    const temp_user = JSON.parse(Cookies.get("userdata_login"));
    this.$store.commit("karyawan/SET_IDUSER", temp_user.data.id);
    // this.$store.dispatch("karyawan/getKaryawanById");
  },
  computed: {
    yotodoLogo() {
      return require("@/assets/img/logo/yogya-logo.png");
    },
    ...system.mapState(["mini"])
    // ...user.mapState(["resultKaryawan"])
  },
  methods: {
    changeMini() {
      this.$store.commit("system/SET_MINI", (this.mini = !this.mini));
    },
    actionItem(item) {
      if (item === "") {
        Cookies.remove("token_hrd");
        Cookies.remove("userdata_login");
        this.$router.go();
      } else {
        this.$router.push(item);
      }
    },
    setOutlet(val) {
      this.account = val.initial;
    },
    refreshToken() {}
  }
};
</script>

<style lang="scss" scoped>
.v-avatar {
  border: 1px solid #008ef8;
  box-sizing: border-box;
  background-blend-mode: normal;
}
.outlet-list {
  height: 62px;
}
</style>
